module.exports = __webpack_public_path__ + "img/JLPT.d1dd6b7f.png";